import { render, staticRenderFns } from "./CrossProductCard.vue?vue&type=template&id=dc486674&scoped=true&"
import script from "./CrossProductCard.vue?vue&type=script&lang=js&"
export * from "./CrossProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc486674",
  null
  
)

export default component.exports